import React from "react";
import { GoogleMap, Marker, useJsApiLoader } from '@react-google-maps/api'



const MapLocation = (props: any) => {

  console.log(props)

  const [map, setMap] = React.useState(null)

  const center = {
    lat: props.lat,
    lng: props.lng,
  }

  const containerStyle = {
    width: 'auto',
    height: '300px',
  }

  const { isLoaded } = useJsApiLoader({
    id: 'google-map-script',
    googleMapsApiKey: 'AIzaSyBxmNF4iTCztkxQB1Q-PEPHntGqjzlS08M',
  })

  const onLoad = React.useCallback(function callback(map) {
    // This is just an example of getting and using the map instance!!! don't just blindly copy!
    const bounds = new window.google.maps.LatLngBounds(center)
    map.fitBounds(bounds)

    setMap(map)
  }, [])

  const onUnmount = React.useCallback(function callback(map) {
    setMap(null)
  }, [])

  return isLoaded ? (
    <GoogleMap
      mapContainerStyle={containerStyle}
      center={center}
      zoom={18}
      onLoad={onLoad}
      onUnmount={onUnmount}
    >

      <Marker
        key={Math.random()}
        position={center}
        label={props.marker}
      />


    </GoogleMap>
  ) : (
    <></>
  )
}

export default MapLocation;